<template>
<div class="list-content col-12 col-sm-6 col-md-4">
  <div class="card">
    <div class="card-header box-btn_l pb-3">
      <div class="list-status" :class="item.status"><span>{{ statusBadge }}</span></div>
      <div class="list-category"><span>{{ kindBadge }}</span></div>
      <div>
        <div class="list-title mb-3"><router-link :to="detailPath">{{ item.event_name }}</router-link></div>
        <div class="list-title">イベント番号: {{ eventNo }}</div>
        <div><span>掲載終了日: {{ item.end_date }}</span></div>
      </div>
    </div>
    <a :href="editPath.path" class="btn btn-secondary mx-3 mt-3 mb-1" :class="editableStyle" @click.prevent="onMoveToEdit()">
      <i class="fa fa-edit float-left"></i>{{ editText }}
    </a>
    <div class="btn">
      <a :href="copyPath.path" class="btn btn-outline-info w-50" :class="copyStyle" @click.prevent="onMoveToInput()">
        <i class="fa fa-copy float-left"></i>コピー</a>
      <a href="" class="btn btn-outline-danger w-50" :class="deleteStyle" data-toggle="modal" :data-target="'#modalDelete-' + item.event_id">
        <i class="fa fa-trash float-left"></i>削除</a>

    </div>
  </div>
  <header-modal class="fade" :id="'modalDelete-' + item.event_id" :ref="'modalDelete-' + item.event_id">
    <h5 slot="header" class="modal-title" id="exampleModalLabel">削除</h5>
    削除してもよろしいでしょうか？
    <button slot="footer" type="button" class="btn btn-secondary" data-dismiss="modal">キャンセル</button>
    <a slot="footer" class="btn btn-primary" @click.prevent="submitDelete()">削除</a>
  </header-modal>
</div>
</template>

<script>
import HeaderModal from 'components/HeaderModal'
import api from 'api'
import util from 'util/common'
import modal from 'util/modal'
const editableStatus = ['draft', 'notapproval', 'approval']

export default {
  props: ['item', 'canApply'],

  components: {
    HeaderModal
  },
  computed: {
    statusBadge: function () {
      return util.lecturerStatusText[this.item.status]
    },
    kindBadge: function () {
      return util.eventKindText[this.item.event_kind]
    },
    eventNo: function () {
      return util.hasEventNo(this.item.event_no) ? util.zeroPadding(this.item.event_no, 5) : ''
    },
    detailPath () {
      return {
        name: 'event_details',
        params: {
          event_kind: this.item.event_kind,
          id: this.item.event_id
        }
      }
    },
    editPath () {
      return this.isNotReport
      ? {
        path: '/report_input',
        query: { id: this.item.event_id }
      }
      : {
        path: '/input',
        query: { id: this.item.event_id }
      }
    },
    editText () {
      return this.isNotReport ? '開催報告' : '編集'
    },
    copyPath: function () {
      return {
        path: '/lecturer/input'
      }
    },
    isEditable () {
      return this.isNotReport ||
      (this.canApply && editableStatus.some(s => s === this.item.status))
    },
    editableStyle () {
      return this.isEditable ? '' : 'disabled'
    },
    isNotReport () {
      return this.item.status === 'notreport'
    },
    copyStyle () {
      return this.canApply ? '' : 'disabled'
    },
    deleteStyle () {
      return this.canApply && editableStatus.some(s => s === this.item.status)
      ? '' : 'disabled'
    }
  },
  methods: {
    onMoveToEdit () {
      if (!this.isEditable) return
      if (this.isNotReport) {
        this.$store.commit('clearEventReport')
      } else {
        this.$store.commit('updateEventForm', this.item)
      }
      this.$router.push(this.editPath)
    },
    onMoveToInput () {
      this.$store.commit('updateEventForm', {
        ...this.item,
        event_id: '',
        status: '',
        event_date_public: '',
        event_date_public_multi: '',
        end_date: ''
      })
      this.$router.push('/input')
    },
    submitDelete () {
      if (!this.isEditable) return

      api.deleteEvent(this, this.item.event_id)
      .then(this.$refs['modalDelete-' + this.item.event_id].hideModal())
      .catch(err => {
        if (err.status === 401) {
          api.onAuthRequired(this)
        } else {
          modal.showErrorModal(this, err)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ListItem.vue?29349287